export const GA_CHECKOUT_CATEGORY = 'checkout';
export const GA_ECOMMERCE_CATEGORY = 'ecommerce';
export const GA_BOOZTLET_LOGIN_CATEGORY = 'my booztlet';
export const GA_BOOZT_LOGIN_CATEGORY = 'my boozt';
export const GA_FILTERS_CATEGORY = 'filters';
export const GA_FILTERS_SORTING_CATEGORY = 'category';
export const GA_SEARCH_CATEGORY = 'search';
export const GA_STORE_POPUP_CATEGORY = 'Country popup';

export const GA_MY_BOOZT_CATEGORY = 'my boozt';
export const GA_ONLINE_RETURN_CATEGORY = 'online return';
export const GA_BOOZTPAY_CATEGORY = 'booztpay';
export const GA_FAVORITES_CATEGORY = 'favourites';
